/**
 * Created by ostapenko.r on 25/12/2014.
 */

angular.module("flipto.components.common.textFormatting",
    [
        'flipto.core.parse',
        'flipto.core.lodash',
        'flipto.core.api.languages'
    ]);